// Bytes to base64 and back with the platform's btoa/atob (browsers and Node 16+), chunked so a large snapshot never
// hits the argument limit of String.fromCharCode.

const CHUNK = 0x8000;

/** Encode bytes as base64. */
export function toBase64(bytes: Uint8Array): string {
  let s = "";
  for (let i = 0; i < bytes.length; i += CHUNK) s += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  return btoa(s);
}

/** Decode base64 to bytes. */
export function fromBase64(b64: string): Uint8Array {
  const s = atob(b64);
  const out = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) out[i] = s.charCodeAt(i);
  return out;
}
